export enum EAdvertisementTargetRole {
  TEACHER = "TEACHER",
  STUDENT = "STUDENT",
}

export type TAdvertisement = {
  id: number;
  url: string | null;
  imageUrl: string | null;
  targetRole: EAdvertisementTargetRole | null;
};

export type TAdvertisementCreateBody = {
  url?: string | null;
  imageEncoded: string;
  targetRole?: EAdvertisementTargetRole | null;
};
